import React, { useMemo } from 'react'
import * as classes from './Videos.module.scss'
import cn from 'classnames'
import Container from '../../../ui/Container/Container'
import SectionTitle from '../../../ui/SectionTitle/SectionTitle'
import { deleteHtmlTag } from '../../../../utils/deleteHtmlTag'
import { getVideoThumbnailUrl } from '../../../../utils/getVideoEmbedUrl'

function VideoCard({ item }) {
    const videoUrl = useMemo(() => (item.videoUrl ? String(item.videoUrl).trim() : ''), [item.videoUrl])

    const posterUrl = item.poster?.url || getVideoThumbnailUrl(item.videoUrl)

    const title = useMemo(() => deleteHtmlTag(item.title, 'all').trim(), [item.title])
    const text = useMemo(() => deleteHtmlTag(item.text, 'p'), [item.text])

    return (
        <article className={classes.Card}>
            <div className={classes.Frame}>
                {videoUrl ? (
                    <a
                        className={classes.Poster}
                        style={posterUrl ? { backgroundImage: `url(${posterUrl})` } : undefined}
                        href={videoUrl}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label={title || 'video'}
                    >
                        <span className={classes.Play}>
                            <svg width='14' height='16' viewBox='0 0 14 16' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                                <path d='M13.5 8 0 16V0z' fill='currentColor' />
                            </svg>
                        </span>
                    </a>
                ) : (
                    <div
                        className={classes.Poster}
                        style={posterUrl ? { backgroundImage: `url(${posterUrl})` } : undefined}
                        aria-label={title || 'video'}
                    />
                )}
            </div>

            {title ? (
                <h3 className={classes.Title}>
                    {videoUrl ? (
                        <a className={classes.TitleLink} href={videoUrl} target='_blank' rel='noopener noreferrer'>
                            {title}
                        </a>
                    ) : (
                        title
                    )}
                </h3>
            ) : null}

            {text ? <p className={classes.Text} dangerouslySetInnerHTML={{ __html: text }} /> : null}
        </article>
    )
}

function Videos({ items, title, lang }) {
    const sectionTitle = useMemo(() => (title ? deleteHtmlTag(title, 'p') : ''), [title])

    if (!items || !items.length) {
        return null
    }

    return (
        <section className={cn(classes.Section, { [classes.LangHY]: lang === 'hy' })} style={{
            backgroundColor: 'white',
        }}>
            <Container>
                {sectionTitle ? <SectionTitle className={classes.SectionTitle} title={sectionTitle} lang={lang} /> : null}

                <div className={classes.Grid}>
                    {items.map((item, index) => (
                        <VideoCard item={item} key={item.id || index} />
                    ))}
                </div>
            </Container>
        </section>
    )
}

export default Videos
